import { useEffect } from 'react';

import { updateFirstLoadedPageIfNecessary } from '../../../telemetry/firstLoadedPageStore';
import { subscribeToPageLoadEvent, unsubscribeFromPageLoadEvent } from '../../../telemetry/loadEvents';

export const useSetFirstLoadedPageSubscription = (): void => {
  useEffect(() => {
    subscribeToPageLoadEvent('Loaded', updateFirstLoadedPageIfNecessary);

    return () => {
      unsubscribeFromPageLoadEvent('Loaded', updateFirstLoadedPageIfNecessary);
    };
  }, []);
};
